import { Component, OnInit } from '@angular/core';
import { navItems } from '../../_nav';
import { LocalStorageService } from '../../provider/local-storage.service';
import { IUserProfile } from '../../model/IUserProfile';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public navItems = navItems;
  user: IUserProfile = {};
  constructor(private storage: LocalStorageService) {

  }
  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  ngOnInit() {
    this.storage.getLoggedUser().then(res => {
      if (res) {
        this.user = res;
      }
    });
  }

  logout() {
    this.storage.logOut();
  }
}
